"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gatsby = require("gatsby");
var _utils = require("../../utils/utils");
require("../../utils/_variables.css");
// Packages

// Components

// Utils

const {
  canHover
} = (0, _utils.getMediaQueries)();

// Styles

const ButtonContainer = _styledComponents.default.a.withConfig({
  displayName: "button__ButtonContainer",
  componentId: "sc-vjctlw-0"
})(["display:flex;background:", ";border-radius:2px;padding:12px;border:1px solid ", ";max-width:100%;text-decoration:none;cursor:pointer;transition:all 0.3s ease-in-out;span{color:", ";font-size:16px;line-height:20px;font-weight:600;}img{filter:brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(149deg) brightness(106%) contrast(102%);}", " &.primary{background:", ";border:1px solid ", ";span{color:", ";}", "}&.secondary{background:transparent;border:none;span{color:", ";}img{filter:brightness(0) saturate(100%) invert(28%) sepia(82%) saturate(4033%) hue-rotate(199deg) brightness(100%) contrast(98%);}", "}&.tertiary{background:", ";border:1px solid ", ";span{color:", ";}", "}&.quaternary{background:", ";border:1px solid ", ";span{color:", ";}", "}&:focus{border:1px solid var(--orca-grey-8-hex);}&.disabled{pointer-events:none;background:var(--ice-grey-1-hex);border:none;span{color:var(--grey-3-hex);}}svg{circle{fill:", ";stroke:", ";transition:all 0.2s ease-in-out;}path{stroke:", ";transition:all 0.2s ease-in-out;}}", ""], props => props.$defaultBackground, props => props.$defaultBorderColor || props.$defaultBackground, props => props.$defaultColor, canHover`
    &:hover {
      background: ${props => props.$activeBackground};
      border: 1px solid
        ${props => props.$activeBorderColor || props.$activeBackground};
      text-decoration: none;
      span {
        color: ${props => props.$activeColor};
      }
    }
  `, props => props.$defaultBackground || "var(--pacific-blue-hex)", props => props.$defaultBorderColor || "var(--pacific-blue-hex)", props => props.$defaultColor || "#fff", canHover`
      &:hover {
        background: ${props => props.$activeBackground || "var(--arctic-blue-hex)"};
        border-color: ${props => props.$activeBorderColor || "var(--arctic-blue-hex)"};
        span {
          color: ${props => props.$activeColor || "#fff"};
        }
      }
    `, props => props.$defaultColor || "var(--pacific-blue-hex)", canHover`
      &:hover {
        background: ${props => props.$activeBackground || "var(--arctic-blue-2-hex)"};
        span {
          color: ${props => props.$activeColor || "var(--arctic-blue-hex)"};
        }
        img {
          filter: brightness(0) saturate(100%) invert(18%) sepia(91%)
            saturate(556%) hue-rotate(166deg) brightness(91%) contrast(100%);
        }
      }
    `, props => props.$defaultBackground || "transparent", props => props.$defaultBorderColor || "var(--pacific-blue-hex)", props => props.$defaultColor || "var(--pacific-blue-hex)", canHover`
      &:hover {
        background: ${props => props.$activeBackground || "var(--arctic-blue-hex)"};
        border-color: ${props => props.$activeBorderColor || "var(--arctic-blue-hex)"};

        span {
          color: ${props => props.$activeColor || "var(--pacific-blue-1-hex)"};
        }
        img {
          filter: brightness(0) saturate(100%) invert(81%) sepia(11%)
            saturate(1058%) hue-rotate(178deg) brightness(101%) contrast(99%);
        }
      }
    `, props => props.$defaultBackground || "var(--palm-green-2-hex)", props => props.$defaultBorderColor || "var(--palm-green-2-hex)", props => props.$defaultColor || "var(--palm-green-6-hex)", canHover`
      &:hover {
        background: ${props => props.$activeBackground || "#fff"};
        border-color: ${props => props.$activeBorderColor || "var(--palm-green-6-hex)"};
        img {
          filter: brightness(0) saturate(100%) invert(10%) sepia(99%)
            saturate(5571%) hue-rotate(181deg) brightness(80%) contrast(96%);
        }
      }
    `, props => props.$circleDefaultColor || undefined, props => props.$borderDefaultColor || undefined, props => props.$iconBorderDefaultColor || undefined, canHover`
    :hover {
      svg {
        circle {
          fill: ${props => props.$circleActiveColor || _utils.colors["pacific-blue-2"].hex};
          stroke: ${props => props.$borderActiveColor || _utils.colors["pacific-blue-2"].hex};
        }
        path {
          fill: ${props => props.$iconActiveColor || undefined};
          stroke: ${props => props.$iconBorderActiveColor || undefined};
        }
      }
    }
  `);
const ButtonContentsContainer = _styledComponents.default.div.withConfig({
  displayName: "button__ButtonContentsContainer",
  componentId: "sc-vjctlw-1"
})(["display:flex;column-gap:", ";justify-content:center;margin:0 auto;"], props => props.columnGap || "10px");
function Button(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ButtonContainer, Object.assign({}, props.functions, {
    className: `${props.type ? props.type : ""} ${props.disabled ? "disabled" : ""} button ${props.buttonClass && props.buttonClass}`
  }, props.buttonAttributes, {
    $activeBackground: props.activeBackground,
    $activeColor: props.activeColor,
    $circleDefaultColor: props.circleDefaultColor,
    $circleActiveColor: props.circleActiveColor,
    $defaultBackground: props.defaultBackground,
    $defaultColor: props.defaultColor,
    $defaultBorderColor: props.defaultBorderColor,
    $activeBorderColor: props.activeBorderColor,
    $iconActiveColor: props.iconActiveColor,
    $borderDefaultColor: props.borderDefaultColor,
    $borderActiveColor: props.borderActiveColor,
    $iconBorderDefaultColor: props.iconBorderDefaultColor,
    $iconBorderActiveColor: props.iconBorderActiveColor
  }, props.linkAttributes, {
    as: props.linkAttributes ? props.linkAttributes.href ? "a" : _gatsby.Link : "button"
  }), /*#__PURE__*/_react.default.createElement(ButtonContentsContainer, {
    columnGap: props.columnGap
  }, props.icon && props.iconPlacement === "left" && props.icon, props.image && props.imagePlacement === "left"( /*#__PURE__*/_react.default.createElement("img", {
    src: props.image,
    alt: props.imageAltText || "button icon"
  })), /*#__PURE__*/_react.default.createElement("span", null, props.buttonText), props.icon && props.iconPlacement === "right" && props.icon, props.image && props.imagePlacement === "right"( /*#__PURE__*/_react.default.createElement("img", {
    src: props.image,
    alt: props.imageAltText || "button icon"
  })))));
}
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "iconPlacement": {
      "defaultValue": {
        "value": "\"right\"",
        "computed": false
      },
      "description": "Where should the icon be placed? (right or left)",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"left\"",
          "computed": false
        }, {
          "value": "\"right\"",
          "computed": false
        }]
      },
      "required": false
    },
    "imagePlacement": {
      "defaultValue": {
        "value": "\"right\"",
        "computed": false
      },
      "description": "Where should the image be placed? (right or left)",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"left\"",
          "computed": false
        }, {
          "value": "\"right\"",
          "computed": false
        }]
      },
      "required": false
    },
    "tab": {
      "defaultValue": {
        "value": "\"new\"",
        "computed": false
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "\"custom\"",
        "computed": false
      },
      "description": "Button Type",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"primary\"",
          "computed": false
        }, {
          "value": "\"secondary\"",
          "computed": false
        }, {
          "value": "\"tertiary\"",
          "computed": false
        }, {
          "value": "\"quaternary\"",
          "computed": false
        }, {
          "value": "\"custom\"",
          "computed": false
        }]
      },
      "required": false
    },
    "activeBackground": {
      "description": "Background color of button when button is active (clicked / hovered / pressed)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "activeColor": {
      "description": "Text color of button when button is active (clicked / hovered / pressed)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "buttonText": {
      "description": "Button text",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "defaultBorderColor": {
      "description": "Default border color of button",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "activeBorderColor": {
      "description": "Border color of button when button is active (clicked / hovered / pressed)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "defaultBackground": {
      "description": "Default background color of button",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleDefaultColor": {
      "description": "Sets default color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleActiveColor": {
      "description": "Sets active color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "defaultColor": {
      "description": "Default text color of button",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "description": "Is button disabled?",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "iconActiveColor": {
      "description": "Sets active color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderDefaultColor": {
      "description": "Sets default color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderActiveColor": {
      "description": "Sets active color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "description": "Button icon (should be GenericIcon)",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "image": {
      "description": "Button image (src)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "imageAltText": {
      "description": "Alt text for button image",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "buttonClass": {
      "description": "Custom class name of button",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "functions": {
      "description": "Button Functions, e.g. { onClick: () => {}}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "linkAttributes": {
      "description": "Link Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "buttonAttributes": {
      "description": "Button Attributes e.g. { type: \"submit\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "iconBorderDefaultColor": {
      "description": "Sets default color of icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconBorderActiveColor": {
      "description": "Sets active color of icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "columnGap": {
      "description": "Gap between elements inside button (e.g. 10px)",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = Button;
exports.default = _default;
Button.propTypes = {
  /**
   * Background color of button when button is active (clicked / hovered / pressed)
   */
  activeBackground: _propTypes.default.string,
  /**
   * Text color of button when button is active (clicked / hovered / pressed)
   */
  activeColor: _propTypes.default.string,
  /**
   * Button text
   */
  buttonText: _propTypes.default.string.isRequired,
  /**
   * Default border color of button
   */
  defaultBorderColor: _propTypes.default.string,
  /**
   * Border color of button when button is active (clicked / hovered / pressed)
   */
  activeBorderColor: _propTypes.default.string,
  /**
   * Default background color of button
   */
  defaultBackground: _propTypes.default.string,
  /**
   * Sets default color of icon circle
   */
  circleDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon circle
   */
  circleActiveColor: _propTypes.default.string,
  /**
   * Default text color of button
   */
  defaultColor: _propTypes.default.string,
  /**
   * Is button disabled?
   */
  disabled: _propTypes.default.bool,
  /**
   * Sets active color of icon
   */
  iconActiveColor: _propTypes.default.string,
  /**
   * Sets default color of border around icon circle
   */
  borderDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of border around icon circle
   */
  borderActiveColor: _propTypes.default.string,
  /**
   * Button icon (should be GenericIcon)
   */
  icon: _propTypes.default.element,
  /**
   * Button image (src)
   */
  image: _propTypes.default.string,
  /**
   * Where should the image be placed? (right or left)
   */
  imagePlacement: _propTypes.default.oneOf(["left", "right"]),
  /**
   * Where should the icon be placed? (right or left)
   */
  iconPlacement: _propTypes.default.oneOf(["left", "right"]),
  /**
   * Alt text for button image
   */
  imageAltText: _propTypes.default.string,
  /**
   * Button Type
   */
  type: _propTypes.default.oneOf(["primary", "secondary", "tertiary", "quaternary", "custom"]),
  /**
   * Custom class name of button
   */
  buttonClass: _propTypes.default.string,
  /**
   * Button Functions, e.g. { onClick: () => {}}
   */
  functions: _propTypes.default.shape(),
  /**
   * Link Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape(),
  /**
   * Button Attributes e.g. { type: "submit"}
   */
  buttonAttributes: _propTypes.default.shape(),
  /**
   * Sets default color of icon border
   */
  iconBorderDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon border
   */
  iconBorderActiveColor: _propTypes.default.string,
  /**
   * Gap between elements inside button (e.g. 10px)
   */
  columnGap: _propTypes.default.string
};
Button.defaultProps = {
  iconPlacement: "right",
  imagePlacement: "right",
  tab: "new",
  type: "custom"
};